import { render, staticRenderFns } from "./veHqCanting.vue?vue&type=template&id=2e52d59e&scoped=true"
import script from "./veHqCanting.vue?vue&type=script&lang=js"
export * from "./veHqCanting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e52d59e",
  null
  
)

export default component.exports